import React, { useState, useEffect, useCallback } from 'react';
import './styles.scss';
import { TalentLogo } from '../../assets/icons/logo';
import { Auth } from "aws-amplify";
import history from '../../utils/history';
import ROUTES from "../../routesConstants";
import { useDispatch, useMappedState } from 'redux-react-hook';
import * as UserAction from '../../store/user/actions';
// import * as RouteAction from '../../store/route/actions';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams
} from "react-router-dom";

export const MenuLateral = (props: any) => {
  console.log("Route1234", useParams)
  console.log("props MENU", props)
  const dispatch = useDispatch();
  const mapState = useCallback(
    state => ({
      path: state.route.path,
      userData: state.user.user
    }),
    []
  );
  const { path,userData } = useMappedState(mapState);
  console.log("MENU",userData)
  const [itemsMenus, setItemsMenu] = useState(userData.routes);

  const [itemsSession, setItemsSession] = useState([
    {
      title: 'Cerrar Sesión',
      action: async () => {
        console.log("Esto es mi logout")
        await Auth.signOut();
        dispatch(UserAction.setAuthenticated(false));
        const userParameters={
          isRegisterBusiness: false,
          cod_negocio: null,
          cod_tercero: null,
          roles:[]
        };
        dispatch(UserAction.setUser(userParameters))
      }
    }
  ]);

  const changeRoute = (route: string) => {
    console.log("Esto es algo cool ", route)
    history.push(route);
  };

  return (
    <div className="menu-section">
      <div className="menu-container">

        <div className="logo">
          <div>Mi logo</div>
        </div>
        <div className="items">

          {itemsMenus.map((item: any, i: any) => {
            return (
              <div key={i} className={`item-menu ${path == item.path ? 'active' : 'inactive'}`}
                onClick={() => changeRoute(item.path)}
              >{item.title}</div>
            )
          })
          }
        </div>

        <div className="items-session">
          {itemsSession.map((item: any, i: any) => {
            return (
              <div key={i} className={`item-session`}
                onClick={() => item.action()}
              >{item.title}</div>
            )
          })
          }
        </div>


      </div>



    </div>
  )
}
